import {Injectable} from '@angular/core';
import {WsTaskDTOModel} from '../../models/ws-task-DTO.model';
import {LokijsService} from '../database/lokijs.service';

@Injectable({
    providedIn: 'root'
})
export class PopulateTasksService {

    constructor(private loki: LokijsService) {
    }

    populateTasks(pdesc: string, jobType: number): WsTaskDTOModel[] {
        const jobTemplateList = this.loki.getCollection('jobtemplate').chain().find({pdesc: pdesc, jobType: jobType}).data();
        const taskList = new Array<WsTaskDTOModel>();
        let task = new WsTaskDTOModel();
        if (jobTemplateList.length > 0) {
            console.log(jobTemplateList);
            for (const job of jobTemplateList) {
                task = null;
                task = this.loki.getTable('tasks', 'nsuk').chain().find({nsuk: job.task}).data();
                if (task) {
                    task[0].option = 0;
                    taskList.push(task[0]);
                }
            }
        } else {
            // TODO check default task
            task = this.loki.getTable('tasks', 'nsuk').chain().find({nsuk: 1}).data();
            if (task) {
                task[0].option = 0;
                taskList.push(task[0]);
            }
        }
        console.log(taskList);
        return taskList;
    }
}
